import { faPaperPlane, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

// Ô nhập bình luận/trả lời dạng pill hiện đại, dùng chung cho bình luận gốc
// (Q&A.js) và trả lời lồng (CommentItem.js).
function CommentBox({ value, setValue, onSubmit, autoFocus, avatar, placeholder }) {
    const canSubmit = Boolean(value && value.trim());

    const handleSubmit = () => {
        if (!canSubmit) return;
        onSubmit();
        setValue('');
    };

    return (
        <div className="flex items-center gap-2">
            <div className="h-9 w-9 min-w-[36px] rounded-full overflow-hidden flex justify-center items-center bg-surface-raised shrink-0">
                {avatar ? (
                    <img
                        className="h-full w-full object-cover"
                        src={`${process.env.REACT_APP_API_PUBLIC_URL}/img/users/${avatar}`}
                        alt="avt"
                    />
                ) : (
                    <FontAwesomeIcon icon={faUser} className="text-content-3 text-sm" />
                )}
            </div>
            <div className="flex-1 flex items-center gap-2 bg-surface border border-line rounded-full pl-4 pr-1.5 py-1.5 focus-within:border-primary-400 transition-colors">
                <input
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSubmit();
                    }}
                    autoFocus={autoFocus}
                    type="text"
                    // text-base (16px) để iOS Safari không tự zoom khi focus input
                    className="flex-1 bg-transparent text-base outline-none min-w-0"
                    placeholder={placeholder || 'Viết bình luận...'}
                />
                <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={!canSubmit}
                    className="h-9 w-9 shrink-0 rounded-full bg-primary-500 text-white flex justify-center items-center disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-600 transition-colors"
                >
                    <FontAwesomeIcon icon={faPaperPlane} className="text-xs" />
                </button>
            </div>
        </div>
    );
}

export default CommentBox;
